import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios"; 

import { setSignupData } from "../../slice/authSlice";
import { endpoints } from "../../services/operations/api";
import "./SignupForm.css";

function SignupForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false); 

  const { firstName, lastName, email, password, confirmPassword } = formData;

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
  
    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      toast.error("All fields are required!");
      return;
    }
  
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
  
    
    const signupData = { firstName, lastName, email, password, confirmPassword };
  
    try {
      setLoading(true);
      console.log("Signup Data:", signupData);
  
      const response = await axios.post(endpoints.SIGNUP_API, signupData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 201 || response.status === 200) {
        toast.success("Signup successful! Redirecting to login...");
        dispatch(setSignupData(signupData));
  
        
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          confirmPassword: "",
        });
  
       
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error("Signup failed! Please try again.");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error(error.response?.data?.message || "Signup failed. Please try again!");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <form onSubmit={handleOnSubmit} className="signup-form">
      <div className="input-group">
        <label className="form-label">
          <p className="form-text">
            First Name <sup className="required">*</sup>
          </p>
          <input
            type="text"
            name="firstName"
            value={firstName}
            onChange={handleOnChange}
            className="form-input-signup"
            required
          />
        </label>
        <label className="form-label">
          <p className="form-text">
            Last Name <sup className="required">*</sup>
          </p>
          <input
            type="text"
            name="lastName"
            value={lastName}
            onChange={handleOnChange}
            className="form-input-signup"
            required
          />
        </label>
      </div>
      <label className="form-label">
        <p className="form-text">
          Email Address <sup className="required">*</sup>
        </p>
        <input
          type="email"
          name="email"
          value={email}
          onChange={handleOnChange}
          className="form-input-email"
          required
        />
      </label>
      <div className="input-group">
        <label className="form-label password-label">
          <p className="form-text">
            Create Password <sup className="required">*</sup>
          </p>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={password}
            onChange={handleOnChange}
            className="form-input-signup"
            required
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="password-toggle-signup"
          >
            {showPassword ? (
              <AiOutlineEyeInvisible fontSize={24} />
            ) : (
              <AiOutlineEye fontSize={24} />
            )}
          </span>
        </label>
        <label className="form-label password-label">
          <p className="form-text">
            Confirm Password <sup className="required">*</sup>
          </p>
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleOnChange}
            className="form-input-signup"
            required
          />
          <span
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="password-toggle"
          >
            {showConfirmPassword ? (
              <AiOutlineEyeInvisible fontSize={24} />
            ) : (
              <AiOutlineEye fontSize={24} />
            )}
          </span>
        </label>
      </div>
      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? "Signing Up..." : "Create Account"}
      </button>
    </form>
  );
}

export default SignupForm;
